import { Component } from '@angular/core';
import { PageBaseComponent } from './page-base.component';
import { environment } from '@environments/environment';


@Component({
  selector: 'my-home',
  styleUrls: ['./styles/styles-wrapper.css'],
  styles: [`
    .k-tilelayout {
      background-color: transparent;
    }
    .card-container {
      text-align: center;
      margin: 24px 12px;
    }
    .card-container h3 {
      margin: 0px;
    }
    .k-card-body {
      padding: 10px 6px;
    }
    .k-card-body p {
      margin: 14px 0 14px 0;
    }
    .k-avatar-solid.k-avatar-primary {
      background-color: #ffffff;
    }
    .k-card-avatar, .k-card .k-avatar {
      margin-right: 0
    }
  `],
  template: `
    
    <div class="wrapper-route-0">

      <kendo-tilelayout [columns]="2">
        <kendo-tilelayout-item *ngFor="let item of items" [col]="item.col" (click)="selectItem($event, item.path)">                
          <kendo-tilelayout-item-body>
            <div class="card-container" *ngIf="authService.hasAccess([item.permission])">
              <kendo-avatar [imageSrc]="item.image"></kendo-avatar> 
              <h3>{{ item.title }}</h3>
            </div>
          </kendo-tilelayout-item-body>
        </kendo-tilelayout-item>
      </kendo-tilelayout>

    </div>

  `
})
export class HomeComponent extends PageBaseComponent {

  public items: any = [
    {
      title: "Vehículos",
      col: 1,
      image: environment.assets.DEFAULT_VEHICLE_COLOR,
      path: 'vehicles',
      permission: "VEHICULOS"
    },
    {
      title: "Servicios",
      col: 2,
      image: environment.assets.DEFAULT_SERVICE_COLOR,
      path: 'services',
      permission: "SERVICIOS"
    },
    {
      title: "Gastos",
      col: 1,
      image: environment.assets.DEFAULT_EXPENSE_COLOR,
      path: 'expenses',
      permission: "GASTOS"
    },  
    {
      title: "Clientes",
      col: 2,
      image: environment.assets.DEFAULT_CUSTOMER_COLOR,
      path: 'customers',
      permission: "CLIENTES"
    },    
    {
      title: "Créditos",
      col: 1,
      image: environment.assets.DEFAULT_CREDIT_COLOR,
      path: 'credits',
      permission: "CREDITOS"
    }, 
    {
      title: "Historial",
      col: 2,
      image: environment.assets.DEFAULT_HISTORY_COLOR,
      path: 'history',
      permission: "HISTORIAL"
    }     
  ];

  public selectItem(event: any, path: any) {
    console.log(event);
    this.router.navigate(['/' + path]);
  }

}